import React, { Component } from 'react';
import './reading-list-modal.css';

export default class ReadingListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCreateForm: false,
      newListName: '',
      newListDescription: ''
    };
  }

  handleToggleList = (listUid, isSelected) => {
    if (this.props.onToggleList) {
      this.props.onToggleList(listUid, isSelected);
    }
  }

  handleCreateList = () => {
    const { newListName, newListDescription } = this.state;
    if (newListName.trim() && this.props.onCreateList) {
      this.props.onCreateList(newListName.trim(), newListDescription.trim());
      this.setState({
        showCreateForm: false,
        newListName: '',
        newListDescription: ''
      });
    }
  }

  render() {
    const { 
      isOpen, 
      onClose, 
      readingLists = [], 
      selectedLists = [], 
      bookTitle = '',
      loading = false
    } = this.props;
    
    const { showCreateForm, newListName, newListDescription } = this.state;

    if (!isOpen) return null;

    return (
      <div className="reading-list-modal-overlay" onClick={onClose}>
        <div className="reading-list-modal" onClick={e => e.stopPropagation()}>
          <div className="reading-list-modal-header">
            <h3>Adicionar à Lista de Leitura</h3>
            <button className="reading-list-modal-close" onClick={onClose}>×</button>
          </div>

          <div className="reading-list-modal-content">
            <div className="reading-list-modal-book-info">
              <p><strong>{bookTitle}</strong></p>
            </div>

            <div className="reading-list-modal-create-section">
              <button 
                className="reading-list-modal-create-btn"
                onClick={() => this.setState({ showCreateForm: !showCreateForm })}
              >
                + Criar Nova Lista
              </button>
              
              {showCreateForm && (
                <div className="reading-list-modal-create-form">
                  <input
                    type="text"
                    placeholder="Nome da lista"
                    value={newListName}
                    onChange={e => this.setState({ newListName: e.target.value })}
                    className="reading-list-modal-input"
                  />
                  <textarea
                    placeholder="Descrição (opcional)"
                    value={newListDescription}
                    onChange={e => this.setState({ newListDescription: e.target.value })}
                    className="reading-list-modal-textarea"
                    rows="2"
                  />
                  <div className="reading-list-modal-create-actions">
                    <button 
                      className="reading-list-modal-btn-cancel"
                      onClick={() => this.setState({ showCreateForm: false, newListName: '', newListDescription: '' })}
                    >
                      Cancelar
                    </button>
                    <button 
                      className="reading-list-modal-btn-create"
                      onClick={this.handleCreateList}
                      disabled={!newListName.trim()}
                    >
                      Criar Lista
                    </button>
                  </div>
                </div>
              )}
            </div>

            <div className="reading-list-modal-lists">
              <h4>Minhas Listas de Leitura</h4>
              {loading ? (
                <div className="reading-list-modal-loading">Carregando...</div>
              ) : readingLists.length === 0 ? (
                <div className="reading-list-modal-empty">
                  <p>Você ainda não possui listas de leitura.</p>
                  <p>Crie sua primeira lista usando o botão acima!</p>
                </div>
              ) : (
                <div className="reading-list-modal-list-items">
                  {readingLists.map(list => {
                    const isSelected = selectedLists.includes(list.uid);
                    return (
                      <div key={list.uid} className="reading-list-modal-list-item">
                        <label className="reading-list-modal-checkbox">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={e => this.handleToggleList(list.uid, e.target.checked)}
                          />
                          <span className="reading-list-modal-checkmark"></span>
                          <div className="reading-list-modal-list-info">
                            <span className="reading-list-modal-list-name">{list.name}</span>
                            {list.description && (
                              <span className="reading-list-modal-list-description">{list.description}</span>
                            )}
                          </div>
                        </label>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}